import { PlanLimitConfigs, BillingCycleConfig } from "../types.ts";

export const CONFLUENCE_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const CONFLUENCE_DEFAULT_UNIT_COUNT = 300;

export const CONFLUENCE_MIN_ENTERPRISE_USER_COUNT = 801;

export const confluenceOfferingSkus = {
    free: "confluence-free",
    standard: "confluence-standard",
    premium: "confluence-premium",
    enterprise: "confluence-enterprise-sku"
} as const;

export const confluenceOfferingSkusArray = Object.values(
    confluenceOfferingSkus
);

export const confluencePlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: confluenceOfferingSkus.free,
        recommendationLimit: 0,
        signupLimit: 150_000
    },
    {
        planName: "Standard",
        offeringSku: confluenceOfferingSkus.standard,
        recommendationLimit: 10,
        signupLimit: 150_000
    },
    {
        planName: "Premium",
        offeringSku: confluenceOfferingSkus.premium,
        recommendationLimit: 250,
        signupLimit: 150_000
    },
    {
        planName: "Enterprise",
        offeringSku: confluenceOfferingSkus.enterprise,
        recommendationLimit: 5000,
        signupLimit: 150_000,
        minUnitCount: CONFLUENCE_MIN_ENTERPRISE_USER_COUNT
    }
];

export const confluenceBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
